module.exports = __webpack_public_path__ + "img/menucn_1_3.b8862784.svg";